import { CanActivateChildFn } from '@angular/router';
import { enrollmentFlagGuard } from './enrollment-flag.guard';

/**
 * Blocks access to /app child routes when the user has a restricted token that
 * requires completing the 2FA enrollment flow. Redirects to /auth/enroll until
 * enrollment is done, at which point EnrollComponent applies the full token
 * (APPLY_SESSION clears enrollmentRequired) and this guard lets navigation through.
 * Shares its gating logic with {@link enrollAllowedGuard} via
 * {@link enrollmentFlagGuard} (allow when NOT required).
 *
 * Passes `captureAttempted` so the /app deep-link the user was forced away from is preserved for
 * EnrollComponent.finish() to restore — CheckAuthService doesn't capture it here because the
 * forced-enrollment user is already authenticated (see enrollment-flag.guard).
 */
export const enrollmentRequiredGuard: CanActivateChildFn = enrollmentFlagGuard(false, '/auth/enroll', true);
